<div mat-dialog-content>
  <p class="text-center">{{ content }}</p>
</div>
<div mat-dialog-actions class="flex justify-center">
  <button mat-flat-button color="primary" (click)="onDismiss()">
    {{ "actions.close" | trans }}
  </button>
</div>
